import { Text } from "../ui";

// Constants for CORS configuration
const CORS_CONFIG = {
  methods: "GET,PUT,POST,DELETE,HEAD,OPTIONS",
  headers: "*",
  exposedHeaders: "*",
  maxAge: "3600"
} as const;

const LIST_CLASSES = "list-decimal list-inside space-y-1";
const CONFIG_BOX_CLASSES = "mt-2 bg-white border rounded p-2 text-xs font-mono";

// Get current origin for CORS configuration
const getCurrentOrigin = () => 
  typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000';

// CORS configuration display component
const CorsConfigDisplay = () => {
  const origin = getCurrentOrigin();
  
  return (
    <div className={CONFIG_BOX_CLASSES}>
      <div><strong>Allowed origins:</strong> {origin}</div>
      <div><strong>Allowed methods:</strong> {CORS_CONFIG.methods}</div>
      <div><strong>Allowed headers:</strong> {CORS_CONFIG.headers}</div>
      <div><strong>Exposed headers:</strong> {CORS_CONFIG.exposedHeaders}</div>
      <div><strong>Max age:</strong> {CORS_CONFIG.maxAge}</div>
    </div>
  );
};

// CORS setup instructions component
const CorsInstructions = () => (
  <ol className={LIST_CLASSES}>
    <li>Open the Azure Portal</li>
    <li>Navigate to your Storage Account</li>
    <li>Go to <strong>Settings → Resource sharing (CORS)</strong></li>
    <li>Click on <strong>Blob service</strong></li>
    <li>Add this CORS rule:</li>
  </ol>
);

// Help component for CORS configuration guidance
export const CorsHelp = () => (
  <div>
    <Text variant="body">
      To use this Azure Storage, CORS (Cross-Origin Resource Sharing) must be configured:
    </Text>
    <CorsInstructions />
    <CorsConfigDisplay />
  </div>
);
